import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "@/components/ui/table";
import { Search, ScrollText } from "lucide-react";

const ACTION_COLOR = { create: "bg-emerald-50 text-emerald-700", update: "bg-blue-50 text-blue-700", delete: "bg-red-50 text-red-700", duplicate: "bg-violet-50 text-violet-700" };

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/audit-logs").then((r) => setLogs(r.data)); }, []);

  const filtered = logs.filter((l) => (l.entity_name + l.email + l.entity + l.action).toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div><h2 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight">Audit Logs</h2><p className="text-slate-500 mt-1">{logs.length} recorded changes</p></div>
      <div className="relative max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
        <Input placeholder="Search logs…" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9 h-11" data-testid="search-audit" />
      </div>
      <Card className="rounded-xl border-slate-200 dark:border-slate-800 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader><TableRow className="bg-slate-50 dark:bg-slate-800/50 hover:bg-slate-50">
              <TableHead>Action</TableHead><TableHead>Entity</TableHead><TableHead>Changes</TableHead>
              <TableHead>By</TableHead><TableHead>IP</TableHead><TableHead>Date & Time</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {filtered.map((l) => (
                <TableRow key={l.id} className="hover:bg-slate-50 dark:hover:bg-slate-800/40" data-testid={`log-${l.id}`}>
                  <TableCell><Badge className={`${ACTION_COLOR[l.action] || "bg-slate-100 text-slate-600"} hover:opacity-100 capitalize`}>{l.action}</Badge></TableCell>
                  <TableCell><span className="text-sm">{l.entity_name}</span><div className="text-xs text-slate-400 capitalize">{l.entity}</div></TableCell>
                  <TableCell className="max-w-xs">
                    {l.changes && Object.keys(l.changes).length > 0 ? (
                      <div className="text-xs text-slate-500 space-y-0.5">
                        {Object.entries(l.changes).slice(0, 3).map(([k, v]) => (
                          <div key={k} className="truncate">{k}: <span className="text-red-500">{String(v.old)}</span> → <span className="text-emerald-600">{String(v.new)}</span></div>
                        ))}
                      </div>
                    ) : <span className="text-xs text-slate-300">—</span>}
                  </TableCell>
                  <TableCell className="text-sm">{l.email}</TableCell>
                  <TableCell className="text-xs text-slate-400">{l.ip}</TableCell>
                  <TableCell className="text-xs text-slate-500">{new Date(l.timestamp).toLocaleString("en-IN")}</TableCell>
                </TableRow>
              ))}
              {filtered.length === 0 && <TableRow><TableCell colSpan={6} className="text-center py-12 text-slate-400"><ScrollText className="h-6 w-6 mx-auto mb-2" /> No logs found.</TableCell></TableRow>}
            </TableBody>
          </Table>
        </div>
      </Card>
    </div>
  );
}
